



import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Map,
  User,
  LogOut,
  ChevronDown,
  FolderKanban,
  MapPinned,
  Users,
  Building2,
  Briefcase,
  UserPlus,
  CreditCard,
  Plane,
  Files,
  Lock,
  UsersRound,
  ReceiptText,
  ShieldCheck
} from "lucide-react";
import Auth from "../Common/Configurations/Auth";

function StaffHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // --- NEW: PERMISSION LOGIC ---
  const allowed = Auth.getPermissions(); 
  const canSee = (screenKey) => allowed.includes(screenKey);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (Auth.logout) {
      Auth.logout();
    } else {
      localStorage.clear();
    }
    navigate("/");
  };

  // --- HIGHLIGHTING LOGIC ---
  const isActive = (path) => {
    const currentPath = location.pathname;
    
    if (path === "/members") {
      return (currentPath === "/members" || 
              currentPath.startsWith("/members/manage") || 
              currentPath.startsWith("/members/view")) && 
              !currentPath.startsWith("/members/documents");
    }
    
    return currentPath.startsWith(path);
  };

  const styles = {
    header: {
      height: "70px",
      backgroundColor: "#ffffff",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 40px",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      borderBottom: "1px solid #f1f5f9"
    },
    logoSection: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer"
    },
    logoBox: {
      width: "38px",
      height: "38px",
      background: "linear-gradient(135deg, #285f39 0%, #cb9861 100%)",
      borderRadius: "10px",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    brandName: {
      margin: 0,
      fontSize: "20px",
      fontWeight: "800",
      color: "#0f172a"
    },
    navLink: (path) => ({
      cursor: "pointer",
      fontSize: "14px",
      padding: "24px 5px",
      transition: "0.2s",
      color: isActive(path) ? "#059669" : "#64748b",
      fontWeight: isActive(path) ? "700" : "500",
      borderBottom: isActive(path)
        ? "3px solid #059669"
        : "3px solid transparent"
    }),
    profileToggle: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "6px 12px",
      backgroundColor: "#f0fdf4",
      borderRadius: "12px",
      cursor: "pointer",
      border: "1px solid #dcfce7"
    },
    dropdown: {
      position: "absolute",
      top: "55px",
      right: 0,
      width: "220px",
      backgroundColor: "#fff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      borderRadius: "16px",
      border: "1px solid #e2e8f0",
      overflow: "hidden",
      padding: "8px"
    },
    dropdownItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 15px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#475569",
      borderRadius: "10px",
      transition: "0.2s"
    }
  };

  return (
    <div style={styles.header}>
      {/* <div onClick={() => navigate("/dashboard")} style={styles.logoSection}>
        <div style={styles.logoBox}>
          <Map size={22} strokeWidth={2.5} />
        </div>
        <h2 style={styles.brandName}>
          Plot<span style={{ color: "#059669" }}>Management</span>
        </h2>
      </div> */}
      <div onClick={() => navigate("/dashboard")} style={styles.logoSection}>
  <div style={styles.logoBox}>
    <MapPinned size={22} strokeWidth={2.5} />
  </div>

  <h2 style={styles.brandName}>
    <span
      style={{
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        textDecorationThickness: "2px",
      }}
    >
      Ma
    </span>
    g
    <span
      style={{
        color: "#56b06f",
        textDecoration: "underline",
        textUnderlineOffset: "4px",
        textDecorationThickness: "2px",
      }}
    >
      nets
    </span>
  </h2>
</div>

      {/* STAFF NAVIGATION LINKS - DYNAMICALLY FILTERED */}
      <div style={{ display: "flex", gap: "30px" }}>
        {canSee("DASHBOARD") && (
          <span style={styles.navLink("/dashboard")} onClick={() => navigate("/dashboard")}>
            Dashboard
          </span>
        )}
        
        {canSee("MEMBERS") && (
          <span style={styles.navLink("/members")} onClick={() => navigate("/members")}>
            Members
          </span>
        )}

        {canSee("PAYMENTS") && (
          <span style={styles.navLink("/receipts")} onClick={() => navigate("/receipts")}>
            Receipts
          </span>
        )}

        {canSee("DOCUMENTS") && (
          <span style={styles.navLink("/members/documents")} onClick={() => navigate("/members/documents")}>
            Documents
          </span>
        )}


        {canSee("LEADS") && (
          <span style={styles.navLink("/leads")} onClick={() => navigate("/leads")}>
            Leads
          </span>
        )}

        {canSee("HOLIDAYS") && (
          <span style={styles.navLink("/holidays")} onClick={() => navigate("/holidays")}>
            Holidays
          </span>
        )}
       
        
      </div>

      <div style={{ position: "relative" }} ref={dropdownRef}>
        <div onClick={() => setShowDropdown(!showDropdown)} style={styles.profileToggle}>
          <div style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#059669",
              borderRadius: "8px",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
            <User size={16} />
          </div>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "#166534" }}>
            {Auth.getFullName()}
          </span>
          <ChevronDown size={14} color="#64748b" />
        </div>

        {showDropdown && (
          <div style={styles.dropdown}>

           {canSee("COMPANYPROFILE") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/company-profile"); setShowDropdown(false); }}>
                <Building2 size={16} /> Company Profile
              </div>
            )}


          {canSee("AGENTS") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/agents"); setShowDropdown(false); }}>
                <Users size={16} /> Agents
              </div>
            )}
            
            {canSee("PROJECTS") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/projects"); setShowDropdown(false); }}>
                <FolderKanban size={16} /> Projects
              </div>
            )}

            {canSee("PLOTS") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/plots"); setShowDropdown(false); }}>
                <MapPinned size={16} /> Plots
              </div>
            )}

            {canSee("STAFF") && (
              <div style={styles.dropdownItem} onClick={() => {navigate("/staff"); setShowDropdown(false)}}>
                <Users size={16} /> Staff
              </div>
            )}

            {canSee("BRANCHES") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/branches"); setShowDropdown(false); }}>
                <Building2 size={16} /> Branches
              </div>
            )}

            {canSee("DESIGNATIONS") && (
              <div style={styles.dropdownItem} onClick={() => { navigate("/designations"); setShowDropdown(false); }}>
                <Briefcase size={16} /> Designations
              </div>
            )}

           

            {canSee("MEMBERREPORT") && (
              <div style={styles.dropdownItem} onClick={() => {navigate("/reports/members"); setShowDropdown(false)}}>
                <UsersRound size={16} /> Member Report
              </div>
            )}

             {canSee("RECEIPTREPORT") && (
              <div style={styles.dropdownItem} onClick={() => {navigate("/reports/receipts"); setShowDropdown(false)}}>
                <ReceiptText size={16} /> Receipt Report
              </div>
            )}

            {canSee("MANAGESCREENS") && (
              <div style={styles.dropdownItem} onClick={() => {navigate("/agent-permissions"); setShowDropdown(false)}}>
                <ShieldCheck size={16} /> Agent Screens
              </div>
            )}


            {/* Always show Change Password so they can manage their own account */}
            <div style={styles.dropdownItem} onClick={() => {navigate("/change-password"); setShowDropdown(false)}}>
              <Lock size={16} /> Change Password
            </div>
            

            <div style={{ height: "1px", backgroundColor: "#f1f5f9", margin: "8px 0" }} />

            <div style={{ ...styles.dropdownItem, color: "#ef4444" }} onClick={handleLogout}>
              <LogOut size={16} /> Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StaffHeader;